import React from 'react';

interface Props {
  children: React.ReactNode;
  style?: React.CSSProperties;
}

const ListItem = ({ children, style, ...props }: Props) => (
  /* eslint-disable jsx-a11y/no-redundant-roles */
  <li role="listitem" style={style} {...props}>
    {children}
  </li>
);

export default ListItem;
